import React from "react";
import { Form, FormGroup, FormText, Input, Label } from "reactstrap";

const MakeAComment = (props) => {

    const { comment, commentAuthor, commentDate, onChangeHandler, isEdit, maxLength } = props;

    return(
        <Form>
            <FormGroup>
                <Label htmlFor="commentInput" className="mt-4" style={{marginTop: 20}}>
                    <strong>Comments</strong>
                    {commentAuthor &&
                    <FormText><i>{commentAuthor}</i> at {commentDate}</FormText>
                    }
                </Label>
                <Input readOnly={!isEdit}
                    id="commentInput"
                    style={{ height: 80 }}
                    className={!isEdit ? '' : 'input-editable'}
                    type="textarea"
                    value={comment}
                    maxLength={maxLength}
                    onChange={onChangeHandler}
                />
            </FormGroup>
        </Form>
    );
}

export default MakeAComment;